<template>
  <form class="newurl" @submit.prevent="submitForm">
    <div class="input">
      <input name="title" placeholder="Tittel (valgfri)" class="text-input" type="text" v-model="newUrl.title" autocomplete="off" />
    </div>
    <div class="input">
      <input name="url" placeholder="Lenke" class="text-input" type="url" v-model="newUrl.url" autocomplete="off" required />
    </div>
    <div class="errors" v-if="errors.length">
      <template v-for="(error, index) in errors" :key="index">
        <p>{{ error }}</p>
      </template>
    </div>
    <PageAddButtons @click="add" />
  </form>
</template>

<script>
import PageAddButtons from './PageAddButtons'
import bookTools from '@/utils/book'
import { mapActions } from 'vuex'
export default {
  emits: ['added'],
  data () {
    return {
      newUrl: {
        title: '',
        url: ''
      },
      errors: []
    }
  },
  methods: {
    add (pageNumber) {
      this.errors = []
      if (this.newUrl.url) {
        if (!bookTools.isUrl(this.newUrl.url)) {
          this.errors.push('Lenken er ikke gyldig')
          return
        }
        if (!bookTools.hasHttp(this.newUrl.url)) {
          this.newUrl.url = `http://${this.newUrl.url}`
        }
        this.addUrl({ pageNumber, title: this.newUrl.title, url: this.newUrl.url }).then(() => {
          this.newUrl.title = ''
          this.newUrl.url = ''
          this.$emit('added')
        })
      } else {
        this.errors.push('Du må skrive inn en lenke')
      }
    },
    submitForm () {
      console.log('Submit')
    },
    ...mapActions(['addUrl'])
  },
  computed: {
    spread () {
      return this.$store.getters.spread
    }
  },
  components: {
    PageAddButtons
  }
}
</script>

<style>
  .errors {
    color: red;
    font-size: 0.9em;
  }
</style>
